/**
 * Tema claro/escuro, no mesmo contrato do Auth Manager (`srv-frontend-react-v1/src/app/theme.ts`).
 *
 * O design system ja traz os DOIS temas (`:root[data-theme='light']`); faltava so o interruptor.
 * Escuro e o padrao - sem atributo -, e o claro liga `data-theme="light"` no `<html>`.
 *
 * A preferencia fica no `localStorage`, e falhar em ler ou gravar NAO quebra nada: navegador com
 * armazenamento bloqueado so volta ao escuro na proxima visita.
 *
 * O tema vale para o PORTAL. O relatorio embutido desenha o proprio fundo: o do Power BI e
 * transparente (acompanha a moldura), o do Inteli Graph e decisao do NIG.
 */

export type Tema = 'escuro' | 'claro'

const CHAVE = 'report-viewer.tema'

export function lerTema(): Tema {
  try {
    return window.localStorage.getItem(CHAVE) === 'claro' ? 'claro' : 'escuro'
  } catch {
    return 'escuro'
  }
}

export function aplicarTema(tema: Tema): void {
  const raiz = document.documentElement
  if (tema === 'claro') raiz.dataset.theme = 'light'
  else delete raiz.dataset.theme
}

export function gravarTema(tema: Tema): void {
  try {
    window.localStorage.setItem(CHAVE, tema)
  } catch {
    // Persistir e opcional: o documento ja mudou de tema, so nao lembra na proxima visita.
  }
}
